<template>    
    <v-snackbar v-model="snack" close-delay="15000">
        {{ message }}
        <template v-slot:actions>
            <v-btn color="pink" variant="text" @click="snack = false">
                關閉
            </v-btn>
        </template>
    </v-snackbar>
</template>
<script setup lang="ts">
const { message } = useMsgState();
const snack = ref(false);
watch(() => message.value, (newVal) => {
    if (!!newVal)
        snack.value = true;
});
watch(() => snack.value, (newVal) => {
    if (!newVal)
        message.value = '';
});

</script>